export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8933.3e41a273.jpg";